import { render, staticRenderFns } from "./ClassesManagerTableWidget.vue?vue&type=template&id=5f3fb12b&scoped=true"
import script from "./ClassesManagerTableWidget.vue?vue&type=script&lang=js"
export * from "./ClassesManagerTableWidget.vue?vue&type=script&lang=js"
import style0 from "./ClassesManagerTableWidget.vue?vue&type=style&index=0&id=5f3fb12b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f3fb12b",
  null
  
)

export default component.exports